import Splide from '@splidejs/splide';


(function () {
  'use strict';

  const clientListSliders = document.querySelectorAll('.slider__client-list');

  if (clientListSliders.length === 0) return;

  function updateSliderMargin() {
    const screenWidth = window.innerWidth;
    const container = document.querySelector('.container');
    const containerWidth = container.offsetWidth;
    const marginLeft = (screenWidth - containerWidth) / 2;

    clientListSliders.forEach(slider => {
      const sliderTest = slider.querySelector('.slider_test');
      if (sliderTest) {
        sliderTest.style.marginLeft = marginLeft + 'px';
      }
    });
  }

  updateSliderMargin();
  window.addEventListener('resize', updateSliderMargin);

  clientListSliders.forEach(slider => {
    var splide = new Splide(slider, {
      rewind: false,
      gap: '24px',
      padding: '30px',
      pagination: false,
      fixedWidth: 350,

      breakpoints: {
        768: {
          perPage: 2,
          fixedWidth: false,
          padding: '15px',
        },
        576: {
          perPage: 1,
          fixedWidth: '90%',
          padding: '15px',
        },
      },
    });
    splide.mount();
  });
  
})();

